import dayjs from 'dayjs';
import {
  CommercialOffer,
  CommercialOffersFlowsListResponse,
  FlowType,
} from '../interfaces/CommercialOffer';
import MerchantService from '../services/Merchant';

export const getCommercialOffersStored = ():
  | {
      value: CommercialOffer[];
      timestamp: dayjs.Dayjs;
      merchant_id: string;
    }
  | undefined => {
  const offersLocal = localStorage.getItem('pepper-commercial-offers-S');
  if (offersLocal) return JSON.parse(offersLocal);
};

export const setCommercialOffersStored = (
  totalOffers: CommercialOffer[],
  merchantId: string
) => {
  const storageData = {
    value: totalOffers,
    timestamp: dayjs().add(4, 'hour'),
    merchant_id: merchantId,
  };
  localStorage.setItem(
    'pepper-commercial-offers-S',
    JSON.stringify(storageData)
  );
};

export const fetchCOffers = async (
  flows: FlowType[]
): Promise<CommercialOffersFlowsListResponse> => {
  try {
    return await MerchantService.getCommercialOffersFlowsList(flows);
  } catch (error) {
    console.error(error);
    return {
      flow_commercial_offers: [],
    };
  }
};

export const fetchCommercialOffersList = async (): Promise<
  CommercialOffer[]
> => {
  let offersList: CommercialOffer[] = [];
  let flowsArray: FlowType[] = [];
  try {
    const offersArray = await fetchCOffers([
      FlowType.CEX,
      FlowType.CBR,
      FlowType.SUS,
    ]);
    if (offersArray && offersArray.flow_commercial_offers.length > 0) {
      offersArray.flow_commercial_offers.forEach((element) => {
        flowsArray = flowsArray.concat(element.flow);
        offersList = offersList.concat(element.commercial_offers);
      });
      setFlowsStored(flowsArray);
    }
    return offersList;
  } catch (error) {
    return [];
  }
};

export const setFlowsStored = (flows: FlowType[]) => {
  localStorage.setItem(
    'pepper-commercial-offers-flows-S',
    JSON.stringify(flows)
  );
};

export const getTimeDifference = (localDate: dayjs.Dayjs): boolean => {
  const nowD = dayjs();
  const isValid = dayjs(localDate).isAfter(nowD);
  return isValid;
};
